<template>
  <Popover>
    <PopoverTrigger class="flex">
      <TriangleAlert class="h-6 w-6 text-red-500" />
    </PopoverTrigger>
    <PopoverContent class="w-80 overflow-hidden border p-0 shadow-lg" align="center">
      <div class="bg-red-500 px-6 py-3 text-center">
        <div class="flex items-center justify-center text-white">
          <TriangleAlert class="h-7 w-7 pr-2" />
          <h2 class="font-medium">
            {{ $t('pages.review.reviewAnalyticsPage.treatmentRate.alert.title') }}
          </h2>
        </div>
      </div>
      <div class="bg-white px-6 py-3 text-center">
        <p class="text-sm text-foreground">
          {{ $t('pages.review.reviewAnalyticsPage.treatmentRate.alert.content') }}
        </p>
      </div>
      <div class="bg-primary px-6 py-3 text-center hover:bg-primary/80">
        <router-link :to="{ name: 'ReviewList' }" class="text-sm font-medium text-white">
          <span class="flex items-center justify-center">
            <BaseIcon name="HeroArrowUturnLeftIconSolid" class="h-7 w-7 pr-2" />
            {{ $t('pages.review.reviewAnalyticsPage.treatmentRate.alert.reply') }}
          </span>
        </router-link>
      </div>
    </PopoverContent>
  </Popover>
</template>

<script>
import { TriangleAlert } from 'lucide-vue-next'

export default {
  components: {
    TriangleAlert
  },
  emits: ['close']
}
</script>
